<template>
  <div
    class="previous-documents-table-wrapper px-2 d-flex flex-grow-1 flex-wrap"
  >
    <div v-if="document.fraud_results" class="d-flex my-4 mx-auto flex-column">
      <h6 class="mb-2">Previous documents</h6>
      <div>
        <b-table
          :fields="fields"
          :responsive="true"
          :show-empty="true"
          :items="previousDocuments"
          class="ui-table previous-documents-table card"
        >
          <template #empty>
            <h6>This document has not been seen before</h6>
          </template>

          <template #cell(document)="{ item: doc }">
            <router-link
              v-if="doc.id"
              class="document-name"
              :to="`/customer/${doc.customer.id}/document/${doc.id}/signals`"
            >
              <div class="filename">{{ doc.name }}</div>
            </router-link>
            <span v-else>Deleted document</span>
          </template>
          <template #cell(customer)="{ item: doc }">
            <router-link
              v-if="doc.customer.id"
              :to="`/customer/${doc.customer.id}`"
            >
              <span>{{ doc.customer.name }}</span>
            </router-link>
          </template>
          <template #cell(date)="{ item: doc }">
            <div v-if="doc.id">
              <span :id="doc.id">{{ formatFromNow(doc.created_at) }}</span>
              <b-tooltip
                :target="doc.id"
                :title="$moment(doc.created_at).format(format.time_format)"
              />
            </div>
          </template>
          <template #cell(owner)="{ item: doc }">
            <span v-if="doc.id">{{ doc.creator.email }}</span>
          </template>
        </b-table>
      </div>
    </div>
    <div v-else class="d-flex w-100 align-items-center justify-content-center">
      <i-spinner></i-spinner>
    </div>
  </div>
</template>

<script>
import format from '../../format';
import { formatFromNow } from '@/utils/date';
import { iSpinner } from '@inscribe/signal';

export default {
  components: {
    iSpinner,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    previousDocuments: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      format,
      fields: [
        { key: 'document', tdClass: 'fs-exclude' },
        { key: 'customer', tdClass: 'fs-exclude' },
        { key: 'date' },
        { key: 'owner' },
      ],
    };
  },
  methods: {
    formatFromNow,
  },
};
</script>

<style lang="scss">
.previous-documents-table-wrapper {
  overflow: auto;
  max-height: 100%;

  div {
    max-width: 800px;
    width: 100%;
  }

  td {
    white-space: nowrap;
  }

  .document-name {
    max-width: 400px;

    .truncated-filename span {
      color: $color-dark-blue-80;
    }
  }
}
</style>
